import { handlePaymentOrder } from './Common';

import { saleSelectors } from 'store/sale/selectors';
import { RootState } from 'store/store';
import { AdyenPaymentMethod } from 'types/BusinessLogic';

export const handlePbbOrder = async (state: RootState, payorEmail?: string) => {
  const {
    payment: { selectedBank },
    companyInfo: { region: country },
  } = state;
  const payorName = saleSelectors.customerNameSelector(state.sale);
  const payorEmailAddress = saleSelectors.toEmailsSelector(state.sale)[0] || payorEmail;

  const paymentDetails = {
    issuerBankId: selectedBank?.bankId,
    issuerBankName: selectedBank?.bankName,
    payorName,
    payorEmailAddress,
    country,
  };

  return handlePaymentOrder(state, AdyenPaymentMethod.PAYBYBANK, paymentDetails);
};
